module.exports = __webpack_public_path__ + "img/IMG-20180803-WA0021.4c5356a1.jpg";